import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, PenSquare, ArrowRight } from 'lucide-react';

import PageBreadcrumb from '../common/PageBreadcrumb';
import PageHeader from '../common/PageHeader';

const CreateRfpSelection = () => {
  const navigate = useNavigate();

  const handleSelectManual = () => {
    navigate('/sourcing/rfps/create/workspace', {
      state: { source: 'manual-builder' },
    });
  };

  const handleSelectAi = () => {
    navigate('/sourcing/rfps/create/ai-input');
  };

  return (
    <>
      <PageBreadcrumb />
      <PageHeader
        title="Create RFP"
        description="Choose how you want to create the RFP."
      />

      <div className="page-container">
        <div
          className="grid-modern-2"
          style={{
            maxWidth: '1000px',
            margin: '0 auto',
            width: '100%',
          }}
        >
          <div className="asset-landing-card" onClick={handleSelectAi}>
            <div
              style={{
                height: '4px',
                background: 'linear-gradient(90deg, #f59e0b 0%, #f97316 100%)',
                width: '100%',
              }}
            />

            <div style={{ padding: '24px' }}>
              <div className="d-flex align-items-center mb-3">
                <div
                  style={{
                    width: '44px',
                    height: '44px',
                    borderRadius: '10px',
                    background: '#fff7ed',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '16px',
                  }}
                >
                  <div style={{ color: '#ea580c' }} className="asset-card-icon">
                    <Sparkles size={24} />
                  </div>
                </div>

                <div className="flex-grow-1">
                  <h4
                    style={{
                      fontSize: '18px',
                      fontWeight: '600',
                      color: 'var(--text-primary)',
                      margin: 0,
                      fontFamily: 'var(--font-family)',
                    }}
                  >
                    AI-Assisted Generation
                  </h4>
                </div>

                <ArrowRight size={20} className="asset-card-arrow" />
              </div>

              <p
                style={{
                  fontSize: '13px',
                  color: 'var(--text-secondary)',
                  margin: '0 0 12px 0',
                  lineHeight: 1.4,
                  fontFamily: 'var(--font-family)',
                }}
              >
                Capture structured project details and leverage AI to generate a comprehensive RFP draft including scope, technical, and commercial sections.
              </p>

              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  color: '#ea580c',
                  fontWeight: 600,
                  fontSize: '13px',
                }}
              >
                Get Started
                <ArrowRight size={16} />
              </div>
            </div>
          </div>

          <div className="asset-landing-card" onClick={handleSelectManual}>
            <div
              style={{
                height: '4px',
                background: 'var(--gold-primary)',
                width: '100%',
              }}
            />

            <div style={{ padding: '24px' }}>
              <div className="d-flex align-items-center mb-3">
                <div
                  style={{
                    width: '44px',
                    height: '44px',
                    borderRadius: '10px',
                    background: '#fff9e6',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '16px',
                  }}
                >
                  <div
                    style={{ color: 'var(--gold-primary)' }}
                    className="asset-card-icon"
                  >
                    <PenSquare size={24} />
                  </div>
                </div>

                <div className="flex-grow-1">
                  <h4
                    style={{
                      fontSize: '18px',
                      fontWeight: '600',
                      color: 'var(--text-primary)',
                      margin: 0,
                      fontFamily: 'var(--font-family)',
                    }}
                  >
                    Manual Setup
                  </h4>
                </div>

                <ArrowRight size={20} className="asset-card-arrow" />
              </div>

              <p
                style={{
                  fontSize: '13px',
                  color: 'var(--text-secondary)',
                  margin: '0 0 12px 0',
                  lineHeight: 1.4,
                  fontFamily: 'var(--font-family)',
                }}
              >
                Open the tabbed document editor for section-wise drafting, review, and manual customization of your RFP.
              </p>

              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  color: 'var(--gold-primary)',
                  fontWeight: 600,
                  fontSize: '13px',
                }}
              >
                Open Editor
                <ArrowRight size={16} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateRfpSelection;
